/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_RomanianInputs */



/**
* | output |
* | --- |
* | "Romanian" |
*
* @param {Speechmatics_Target_Language_RomanianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_romanian = /** @type {((inputs?: Speechmatics_Target_Language_RomanianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_RomanianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Roumain")
	if (locale === "de") return /** @type {LocalizedString} */ ("rumänisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("rumeno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("румынский")
	if (locale === "es") return /** @type {LocalizedString} */ ("rumano")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("罗马尼亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ルーマニア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रोमानियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("romeno")
	return /** @type {LocalizedString} */ ("Romanian")
});